import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ClosingSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="py-20 md:py-28 relative" data-testid="closing-section">
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-[var(--bg-secondary)] to-[var(--bg-primary)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="space-y-8"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white italic">
            What Comes Next?
          </h2>
          <p className="text-[var(--text-secondary)] text-lg leading-relaxed">
            Artificial intelligence is changing the systems people have depended on for generations.
            Raulvin Coke studies those shifts early, translates what they mean, and helps people and
            institutions make better decisions before change becomes crisis.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#newsletter"
              onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="newsletter-section"]')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white px-7 py-3.5 rounded-lg font-semibold transition-all flex items-center justify-center gap-2"
            >
              Subscribe to Future Signals
              <ArrowRight className="w-4 h-4" />
            </a>
            <Link
              to="/speaking"
              className="border border-[rgba(124,58,237,0.3)] hover:border-[var(--accent-violet)] text-white px-7 py-3.5 rounded-lg font-medium transition-all hover:bg-[rgba(124,58,237,0.1)] text-center"
            >
              Invite Raulvin to Speak
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingSection;
